export default __webpack_public_path__ + "static/media/orders.15f777bd.svg";